var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:['sort-table-header', _vm.sortClass, _vm.wrapperClasses],attrs:{"aria-controls":_vm.ariaControlId},on:{"click":_vm.sort}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }